export default "__VITE_ASSET__CQuaiWp1__"